import React from 'react'
import logo from '../../assets/images/eSprawozdania_StartPage.svg'
import Button from '@material-ui/core/Button'
import UploadFile from '../../containers/UploadFile'
import LicencjaHeader from './LicencjaHeader'
import StartFooter from './StartFooter'
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline'
import { filmURL } from '../../lib/consts'

class StartSuccessPage extends React.Component {
  render() {
    const {
      licencja,
      onUpload,
      onSetCzyWyborDaty,
      onCloseErrorDialog,
    } = this.props
    return (
      <>
        <section>
          <header>
            <LicencjaHeader licencja={licencja} />
          </header>
          <main>
            <img src={logo} alt="logo" />
            <h2>Witamy w programie</h2>
            <h1>e-Sprawozdania Finansowe</h1>
            <p className="disabled-headline-5 subheader">
              Otwórz plik z e-Sprawozdaniem, aby rozpocząć jego edycję.
              <br />
              Możesz też utworzyć nowe e-Sprawozdanie.
            </p>
            <div className="buttons">
              <UploadFile
                label="OTWÓRZ PLIK"
                filter=".xml,.zip,.lzh"
                onUpload={onUpload}
                onCloseErrorDialog={onCloseErrorDialog}
                isErrorDialog
              />
              <Button
                className="lastButton"
                onClick={() => onSetCzyWyborDaty()}
                color="primary"
                variant="outlined"
              >
                UTWÓRZ NOWE E-SPRAWOZDANIE
              </Button>
            </div>
          </main>
          <div className="watch">
            <p className="medium-emphasis-body-1">Zobacz film</p>
            <a href={filmURL} target="_blank" rel="noopener noreferrer">
              <PlayCircleOutlineIcon className="icon" color="primary" />
            </a>
          </div>{' '}
        </section>
        <footer>
          <StartFooter />
        </footer>
      </>
    )
  }
}

export default StartSuccessPage
